import { ActivityStage } from '@showbie-socrative/socrative-utils';

import { effectiveGradingWeightForQuestions } from '~teacher/components/ActivityResult/scoreCalculation';
import { mapQuestionsToResultsTableQuestions } from '~teacher/components/ActivityResult/util/mapQuestions';
import { populateParticipants } from '~teacher/components/ActivityResult/util/mapStudentResponses';
import {
  Participant,
  ResultsTableQuestion,
} from '~teacher/components/ResultsGrid/ResultsTable';
import { Activity, QuestionScore } from '~teacher/models/activities';
import { QuizAnswer } from '~teacher/models/quizzes';

import { NormalizedQuestion } from './normalizeQuestions';
import { NormalizedResponse } from './normalizeResponses';
import { NormalizedStudent } from './normalizeStudent';

interface ParsedResultData {
  resultsTableQuestions: ResultsTableQuestion[];
  participants: Participant[];
  maxScore: number;
  activityInstanceId: number;
  activityStage: ActivityStage;
  passRate?: number;
}

export function parseResultData({
  activity,
  questions,
  responses,
  answers,
  students,
  questionScores,
}: {
  activity: Activity;
  questions: NormalizedQuestion;
  responses: NormalizedResponse;
  students: NormalizedStudent;
  answers: Record<string, QuizAnswer>;
  questionScores: Record<string, QuestionScore>;
}): ParsedResultData {
  const maxScore = effectiveGradingWeightForQuestions({
    questions: Object.values(questions.entities),
    questionScores,
  });

  const resultsTableQuestions = mapQuestionsToResultsTableQuestions({
    responses: responses,
    students: Object.values(students.entities ?? {}),
    questionScores: questionScores,
    order: questions.byOrder,
    questions: questions.entities,
  });

  const participants = populateParticipants({
    students,
    responses,
    questions,
    questionScores,
    answers,
  });

  return {
    resultsTableQuestions,
    participants,
    activityInstanceId: activity.id,
    activityStage: activity.activityStage,
    maxScore,
    passRate: activity.passRate,
  };
}
